export default class PoliticaAtrasos {
    constructor() {
        this.id = null;
        this.descricao = null;       
        this.atrasoMaximoDiaMinuto = null;       
        this.saidaAntecipadaMaximoDiaMinuto = null;       
        this.excessoIRMaximoDiaMinuto = null;
    }    
}